// ProtectedRoute.js
import React from "react";
import { Navigate, Outlet, Route, useLocation } from "react-router-dom";
import { getIdToken } from "../Auth/authProvider";

const ProtectedRoute = ({ element: Element, ...rest }) => {
  const location = useLocation();
  if (
    !sessionStorage.getItem("app_token") &&
    window.location.pathname !== "/entrance"
  ) {
    return <Navigate replace='/home' />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
